import { h } from '@stencil/core';

const NavLeft = () => {
  return (
    <svg width="25" height="32" viewBox="0 0 25 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_235_2843)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5858 3.58582L18.4143 6.41424L11.8285 13L18.4143 19.5858L15.5858 22.4142L6.17163 13L15.5858 3.58582Z" fill="#fff" />
      </g>
      <defs>
        <filter id="filter0_d_235_2843" x="0.171631" y="0.585815" width="24.2426" height="30.8284" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_235_2843" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_235_2843" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default NavLeft;
